exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-details .modal-dialog {\n  width: 500px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/report-details-modal/report-details-modal.component.scss
// module id = ../../../../../src/app/shared/components/report-details-modal/report-details-modal.component.scss
// module chunks = main